'use client'

// All Theme 18 global styles are now in public/themes/Theme_18/theme_18.css
// which is loaded synchronously via <link> in layout.tsx — no flash on SSR.
// This component is kept as a no-op for backward compatibility.

const PetCareGlobalStyles = () => null

export default PetCareGlobalStyles
